import { Fragment } from 'react';
import { Link } from 'react-router-dom';

import { getTestProps } from '../../../lib/helpers';

import LinkButton from '../../LinkButton/LinkButton';
import TopNavPanel from '../TopNavPanel/TopNavPanel';

const linkClasses =
  'py-3 hover:no-underline hover:text-blue focus:no-underline focus:text-blue';

const MobileTopNavItems = ({ mainItems, sideItems, testId }) => (
  <div
    className="bg-indigo-950 flex flex-col fixed bottom-0 top-14 left-0 text-white z-20 w-full 
              pr-2 pt-4 overflow-y-overlay scrollbar-sm
              group-data-[state=closed]:translate-x-full transition-transform"
  >
    {mainItems.map(({ key, label, url, items }) =>
      url ? (
        <Link
          className={
            linkClasses + ' pl-6 w-full hover:text-blue text-2xl font-bold'
          }
          key={key}
          to={url}
          {...getTestProps(testId, `link-${key}`)}
        >
          {label}
        </Link>
      ) : (
        <TopNavPanel
          key={key}
          label={label}
          items={items}
          {...getTestProps(testId, `panel-${key}`, 'testId')}
        />
      ),
    )}

    <div className="fixed bottom-0 flex flex-wrap w-full items-center px-4 bg-indigo-950 py-6">
      {sideItems.map(({ key, label, url }, index) => (
        <Fragment key={key}>
          <Link
            className={linkClasses}
            to={url}
            {...getTestProps(testId, `link-${key}`)}
          >
            {label}
          </Link>
          {index < sideItems.length - 1 && <span className="px-4">|</span>}
        </Fragment>
      ))}

      <LinkButton
        buttonSize="sm"
        to="/register"
        additionalClasses="rounded-[50px] ml-auto"
        {...getTestProps(testId, `signup`)}
      >
        Start for free
      </LinkButton>
    </div>
  </div>
);

export default MobileTopNavItems;
